"use client";
import React, { createContext, useContext, useMemo } from "react";
import Loaders from "@stadium/ui/src/components/loaders/loaders";
import useFetchConfig from "./use-fetch-config";

export const ConfigContext = createContext();

export const useConfig = (selector) => selector(useContext(ConfigContext));

const ConfigProvider = ({
  children,
  eshop = true,
  programId = "2",
  programIdentifier = "snacks",
  loadChildrenOnLoading = false,
  value: providerValue,
}) => {
  const configPayload = {
    eshop,
    program_id: programId,
  };

  const { configData, isLoading } = useFetchConfig({
    configPayload,
    programIdentifier,
    enabled: !providerValue,
  });

  const value = useMemo(
    () => ({
      config: providerValue || configData,
    }),
    [configData, providerValue],
  );

  return (
    <ConfigContext.Provider value={value}>
      {isLoading && !loadChildrenOnLoading ? (
        <Loaders.PageLoader wrapperClass="pageLoaderwrap visible-bg" />
      ) : (
        children
      )}
    </ConfigContext.Provider>
  );
};

export default ConfigProvider;
